import { Component as ReactComponent } from 'react';
import { CommonContext } from '../contexts/CommonContext';

export class Component extends ReactComponent {
  static contextType = CommonContext;
}

export default Component;